module.exports = __webpack_public_path__ + "media/images/design/images/h2_crowd-e91d05b138244b27c8e3940acc637c81.png";